import { createFeatureSelector, createSelector } from '@ngrx/store';

import { HitListsState, hitListsFeatureKey, selectAllHitList } from './hitlists.reducer';

export const selectHitListsState = createFeatureSelector<HitListsState>(hitListsFeatureKey);

export const selectHitListsStatus = createSelector(selectHitListsState, (state) => state.hitListsStatus);

export const selectHitLists = createSelector(selectHitListsState, (state) => selectAllHitList(state.hitLists));
